import { useIntl } from '@capsicum/common';
import { useFurthestClaimableSurvey } from '@capsicum/features/survey/shared';
import { useNCWBalance } from '@capsicum/socios-core';

import { PollCard } from '../../../ui/poll-card';
import { CardSectionSkeleton } from '../WalletPartnerDetails.skeletons';
import { SectionHeader, SectionSubtitle, SectionTitle, SectionWrapper } from '../WalletPartnerDetails.styled';

type StakedSectionProps = {
	partnerId: string;
	shortCode: string;
};

export const StakedSection = ({ partnerId, shortCode }: StakedSectionProps) => {
	const { $t } = useIntl();
	const { getTokenBalanceBy } = useNCWBalance();
	const { claimingDate, hasVotedSurveys, surveyId, surveysLoading, votingDate } =
		useFurthestClaimableSurvey(partnerId);

	const stakedAmount = Number(getTokenBalanceBy(tb => tb.shortCode === shortCode)?.stakedAmount) ?? 0;

	if (surveysLoading) {
		return <CardSectionSkeleton />;
	}

	if (!stakedAmount) return null;

	return (
		<SectionWrapper>
			<SectionHeader>
				<SectionTitle>{$t('wallet.partnerDetails.staked.title')}</SectionTitle>
				<SectionSubtitle>{`${stakedAmount || 0} ${shortCode}`}</SectionSubtitle>
			</SectionHeader>

			{stakedAmount > 0 && hasVotedSurveys && (
				<PollCard
					claimingDate={claimingDate}
					shortCode={shortCode}
					surveyId={surveyId}
					votingDate={votingDate}
				/>
			)}
		</SectionWrapper>
	);
};
